function toggleClass(element, targetClass) {
    let classes = element.className.match(/\S+/g) || []
    let index = classes.indexOf(targetClass);

    if (index >= 0) {
        classes.splice(index, 1)
    } else {
        classes.push(targetClass)
    }

    element.className = classes.join(' ');
}

function hasClass(element, targetClass) {
    return element.className.indexOf(targetClass) !== -1;
}

function removeClass(elements, targetClass) {
    if (!elements) {
        return;
    }

    if (typeof (elements) === 'string') {
        elements = document.querySelectorAll(elements);
    } else if (elements.tagName) {
        elements = [elements];
    }

    var reg = new RegExp('(^| )' + targetClass + '($| )', 'g');

    for (var i = 0; i < elements.length; i++) {
        elements[i].className = elements[i].className.replace(reg, ' ');
    }
}

function addClass(element, targetClass) {
    var nc = targetClass.split(",");

    for (var i = 0; i < nc.length; i++) {
        if ((" " + element.className + " ").indexOf(" " + nc[i] + " ") == -1) {
            element.className += " " + nc[i];
        }
    }
    return element;
}

module.exports = {
    toggleClass,
    hasClass,
    removeClass,
    addClass
};


// WEBPACK FOOTER //
// ./resources/js/utils/_class-handlers.js